import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SettingService } from '../services/settingService/setting.service';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { ToastrService } from 'ngx-toastr';
import { PageEvent } from '@angular/material/paginator';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ConfirmDialogModel, ConfirmDialogComponent } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'app-login-details',
  templateUrl: './login-details.component.html',
  styleUrls: ['./login-details.component.scss']
})
export class LoginDetailsComponent implements OnInit {    
  currentUser: any;
  organizationId: string;
  databaseId:string;
  responseHolder: any;
  loginDetailsList: any; 
  value = '';
  filterText: any;
  paginatorTotalLength: any; 
  pageIndex: any;
  pageSize: any;
  currentData: PageEvent;
  OfficeIDList: any=[];
  myOfficeID: any;
  ShowNoRecordFound:boolean=false;
  formDialog: FormGroup;
  
  editType = {
    messageTemplateID: 0,
    subject: 0,
    message: "",   
  }
  pageModelData = {
    pageIndex: 0,
    pageSize: 10,
    searchValue: '',
  };
  spinner:boolean=false;
  dataSource: any=[]=[];
  displayedColumns: string[] = [];
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  
  constructor(private loaderService: LoaderService, private toastr: ToastrService, private statusConst: StatusConstant,
     private reusableClass: ReusableClasses, private dialog: MatDialog, private settingsService: SettingService,
     private encryptionAlgo: EncryptionService,private formBuilder: FormBuilder) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.organizationId = sessionStorage.getItem('organizationID');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.currentUser = jwt_decode(token);
     var offices = JSON.parse(sessionStorage.getItem('officeList'));
      offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID)
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });
  }

  ngOnInit(): void {   
    this.dataSource.sort = this.sort;
    this.setDisplayedColumns();  
    this.getAllMessageTemplate(this.pageModelData);
  }
  
  setDisplayedColumns() {   
    this.displayedColumns  = ['fullName','email','organizationName', 'officeName', 'lastLogin'
    , 'totalLoginCount', 'last30DaysLoginCount'];
  }

  
  getAllMessageTemplate(pageData: any) {
    this.ShowNoRecordFound=false;
    this.loaderService.show();
    var ReqModel={
      // userID: this.currentUser.UID,     
      // officeID: this.myOfficeID,    
      // organizationID: Number(this.organizationId),
      // officeIDList: this.OfficeIDList,
      // pageIndex : pageData.pageIndex,
      // pageSize :pageData.pageSize
    }      
    this.settingsService.GetLoginDetails(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data!=null) {
        //  this.loginDetailsList = this.responseHolder.data.subjectTemplateModel;
        this.dataSource = new MatTableDataSource<any>();      
        this.responseHolder = this.responseHolder.data;
          this.responseHolder.map((res) => {
            if (res.firstName != null) {
              res.firstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.firstName);
            }
            if (res.lastName != null) {
              res.lastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.lastName);
            }

           // if (res.lastName != null) {
              res.fullName = res.firstName+" "+res.lastName;
           // }

            if (res.email != null) {
              res.email = this.encryptionAlgo.get(this.reusableClass.decryptionKey,res.email);
            }          
            this.loginDetailsList =this.responseHolder;   
            
            this.dataSource.data =this.loginDetailsList;
            this.dataSource.sort = this.sort;    
           //res.isActive = res.isActive === true ? 'Active' : 'In-Active';
          // res.emailConfirm = res.emailConfirm === true ? 'Yes' : 'No';
         //  res.phoneConfirm = res.phoneConfirm === true ? 'Yes' : 'No';
            return res;
          });
          // this.paginatorTotalLength = this.responseHolder.data.totalCount;
          // this.pageModelData.pageIndex = this.responseHolder.data.pageIndex;
          // this.pageIndex = this.responseHolder.data.pageIndex;
          // this.pageSize = pageData.pageSize;
          if(this.loginDetailsList.length>0){
            this.ShowNoRecordFound=false;
          }else{
            this.ShowNoRecordFound=true;
           }    
        }
        else {
          this.ShowNoRecordFound=true;
          this.loginDetailsList=[];         
          this.loaderService.hide();
        }
      }
      else {
        this.ShowNoRecordFound=true;
        this.loginDetailsList=[];
        this.loaderService.hide();
      }
    });
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  CallNextPrevPageData(pageData: PageEvent) {
    this.currentData = pageData;
    this.pageModelData.pageIndex = pageData.pageIndex;
    this.pageModelData.pageSize = pageData.pageSize;
    this.pageModelData.searchValue = this.value.trim();
    this.getAllMessageTemplate(this.pageModelData);
  }

  close() {
    this.dialog.closeAll();
  }
  
}